import { Seller } from './seller';

export class SellerBatchChanges {
    inserts: Seller[];
    updates: Seller[];
    deletes: number[];
}
